/**
 * Site público no painel: catálogo das configurações (do cliente do módulo, o mesmo que o site lê no build),
 * nomes das seções das páginas fixas e a situação da atualização do site (content.v_site_status).
 */
export {
  REBUILD_HOOK_KEY, SITE_SECTION_BLOCK, SITE_SETTING_FIELDS, SITE_SETTING_GROUPS, validateSiteSetting,
  type SiteSettingField,
} from "../../client/site-catalog";

/** Nome, no painel, de cada seção (chave do bloco site_section; ver apps/site/src/lib/page-registry.ts). */
export const SITE_SECTION_LABELS: Record<string, string> = {
  seo: "SEO (título e descrição nos buscadores)",
  hero: "Abertura",
  text: "Textos da página",
  messages: "Manifesto (seis perguntas)",
  worlds: "Três dimensões",
  about: "Como trabalhamos",
  evidence: "A tese (evidências)",
  results: "Como medimos",
  projectTypes: "Tipos de projeto",
  areas: "Áreas de atuação",
  cta: "Chamada final",
  sobre: "Conteúdo da página",
  capabilities: "Capacidades técnicas",
  offer: "Oferta",
  page: "Conteúdo da página",
  doc: "Texto do documento",
  quote: "Citação",
  firstPerson: "Em primeira pessoa",
  achievements: "Conquistas",
  impactAreas: "Áreas de impacto",
  education: "Formação",
  career: "Carreira",
  teaching: "Docência",
  competencies: "Competências",
  covid: "COVID-19",
  credentials: "Formação e títulos (autoridade)",
  dose: "Método D.O.S.E.",
  mechanism: "Mecanismo em 10 passos",
  talks: "Palestras",
  otherThemes: "Outros temas",
  agenda: "Roteiro-base",
  evidenceMore: "Mais evidências",
  bio: "Bio curta",
  bioLong: "Bio longa",
  contacts: "Contatos para a imprensa",
  nameUsage: "Como citar",
  dimensions: "Dimensões do IMG",
  stages: "Estágios do IMG",
  levels: "Níveis do inventário",
  questions: "Perguntas da conversa",
  minutes: "Roteiro da conversa",
  social: "Redes",
  consultoria: "Menu: Consultoria",
  sistemas: "Menu: Sistemas",
  educacao: "Menu: Educação",
  footer: "Rodapé",
};

export type SiteBuildStatus = "pending" | "triggering" | "triggered" | "live" | "failed" | "unconfirmed";

export interface SiteStatus {
  org_id: string;
  hook_configured: boolean;
  hook_enabled: boolean;
  hook_host: string | null;
  secret_ref: string | null;
  check_url: string | null;
  debounce_seconds: number;
  hook_updated_at: string | null;
  current_id: string | null;
  current_status: SiteBuildStatus | null;
  current_due_at: string | null;
  current_triggered_at: string | null;
  current_changes: number | null;
  current_reasons: string[] | null;
  current_error: string | null;
  last_id: string | null;
  last_status: SiteBuildStatus | null;
  last_live_at: string | null;
  last_finished_at: string | null;
  last_error: string | null;
  live_at: string | null;
}

export interface SiteBuild {
  id: string;
  status: SiteBuildStatus;
  reasons: string[];
  changes: number;
  manual: boolean;
  requested_at: string;
  due_at: string;
  attempts: number;
  triggered_at: string | null;
  http_status: number | null;
  last_error: string | null;
  built_at: string | null;
  live_at: string | null;
  finished_at: string | null;
}

export const REASON_LABEL: Record<string, string> = {
  "content.post_published": "publicação",
  "content.entry_archived": "arquivamento",
  "content.site_settings": "configuração",
  "content.redirects": "redirecionamento",
  "content.menus": "menu",
  "content.menu_items": "menu",
  "content.faq": "perguntas frequentes",
  "content.testimonials": "depoimento",
  "media.item_published": "mídia",
  "cases.published": "caso publicado",
  "cases.withdrawn": "caso retirado",
  manual: "pedido manual",
};
